var map = {
	"./7eleven.png": "d861",
	"./abs.png": "6f50",
	"./airtasker.png": "8f6c",
	"./airwallex-b.png": "ea76",
	"./airwallex.png": "b254",
	"./emprevo.png": "83eb",
	"./fuel.png": "bba1",
	"./iconic.png": "22b3",
	"./ivy.png": "c019",
	"./kristal.png": "6ca8",
	"./mco.png": "0a6d",
	"./medibank.png": "a3d7",
	"./mylearners.png": "4395",
	"./newlook.png": "df1f",
	"./nrs.png": "8749",
	"./nzrelay.png": "6626",
	"./saleo.png": "bcb9",
	"./sunny.png": "0cda",
	"./velocity.png": "8a71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8405";